import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import {
  collection,
  getDocs,
  serverTimestamp,
  updateDoc,
  doc,
  getFirestore,
  addDoc,
  onSnapshot,
  getDoc,
  setDoc,
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";
import { db } from "../firebaseConfig";
import Nav from "./Nav";
import Sidebar from "./Sidebar";
import { useNavContext } from "../context/NavContext";
import Generador from "./Generador";
import Modal from "react-modal";
import moment from "moment";
import DatePicker, { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";

moment.locale("es");
registerLocale("es", es);
// Establece la función de inicialización de react-modal para evitar un aviso de desenfoque de accesibilidad
Modal.setAppElement("#root");

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    border: "none",
    borderRadius: "5px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    padding: "20px",
    maxWidth: "800px",
    width: "100%",
    height: "500px",
    maxHeight: "90vh",
    overflow: "auto",
    fontFamily: "Roboto, sans-serif", // Aplica la fuente Roboto
    "::WebkitScrollbar": {
      width: "none",
      background: "transparent",
    },
    /* Ocultar scrollbar en IE y Edge */
    msOverflowStyle: "none",
    /* Ocultar scrollbar en Firefox */
    scrollbarWidth: "none",
  },
  label: {
    display: "block",
    marginBottom: "10px",
  },
  input: {
    width: "100%",
    padding: "8px",
    marginBottom: "20px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
  },
  button: {
    width: "50%", // Centra el botón de agregar
    padding: "10px",
    borderRadius: "5px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    fontSize: "16px",
    display: "flex",
    justifyContent: "center",
    margin: "0 auto",
    fontWeight: "700",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
};

const customStyles2 = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "500px",
    padding: "20px",
    borderRadius: "5px",
    backgroundColor: "#fff",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    border: "none",
    fontFamily: "Roboto, sans-serif",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 9999,
  },
  h2: {
    fontSize: "1.5rem",
    color: "#333",
    marginBottom: "20px",
    textAlign: "center",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  label: {
    fontSize: "1rem",
    color: "#666",
    marginBottom: "5px",
  },
  input: {
    padding: "10px",
    fontSize: "1rem",
    borderRadius: "5px",
    border: "1px solid #ddd",
    outline: "none",
    transition: "border-color 0.3s ease",
  },
  inputFocus: {
    borderColor: "#007bff",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  button: {
    padding: "10px 20px",
    fontSize: "1rem",
    borderRadius: "5px",
    border: "none",
    color: "#fff",
    backgroundColor: "#007bff",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    flex: "1", // Make buttons take equal space
    margin: "0 5px", // Space between buttons
  },
  buttonCancel: {
    backgroundColor: "#6c757d",
  },
  buttonHover: {
    backgroundColor: "#0056b3",
  },
  buttonCancelHover: {
    backgroundColor: "#5a6268",
  },
};

const modalNoCotizacion = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "500px",
    padding: "20px",
    borderRadius: "5px",
    backgroundColor: "#fff",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    border: "none",
    fontFamily: "Roboto, sans-serif",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 9999,
  },
  h2: {
    fontSize: "20px",
    color: "#333",
    marginBottom: "15px",
    textAlign: "left",
  },
  description: {
    fontSize: "14px",
    color: "#666",
    marginBottom: "20px",
    textAlign: "justify",
    lineHeight: "1.5",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  radioGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  radioLabel: {
    fontSize: "1rem",
    color: "#666",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },

  infoIcon: {
    fontSize: "1rem",
    color: "#007bff",
  },
  inputGroup: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    marginLeft: "45px",
    marginTop: "10px",
    marginBottom: "10px",
  },
  inlineLabel: {
    fontSize: "0.9rem",
    color: "#666",
  },
  smallInput: {
    width: "100px",
    padding: "5px",
    fontSize: "0.9rem",
    borderRadius: "5px",
    border: "1px solid #ddd",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center", // Alinea los botones a la izquierda
    marginTop: "20px",
    gap: "10px", // Espaciado entre botones
  },
  button: {
    padding: "8px 15px", // Reduce el tamaño de los botones
    fontSize: "0.9rem", // Tamaño de texto más pequeño
    borderRadius: "5px",
    border: "none",
    color: "#fff",
    backgroundColor: "#007bff",
    cursor: "pointer",
  },
  buttonCancel: {
    backgroundColor: "#6c757d",
  },
};

const GeneradorModal = ({ editingReport }) => {
  const [reportes, setReportes] = useState([]);
  const { proximasAVencer, proximosEventos } = useNavContext();
  const [numeroReporte, setNumeroReporte] = useState("");
  const [cliente, setCliente] = useState("");
  const [clientes, setClientes] = useState([]);
  const [productos, setProductos] = useState([]);
  const [asunto, setAsunto] = useState("");
  const [fechaReporte, setFechaReporte] = useState(new Date());
  const [usuario, setUsuario] = useState("");
  const [planta, setPlanta] = useState("");
  const [divisa, setDivisa] = useState("MXN");
  const [area, setArea] = useState("");
  const [referencia, setReferencia] = useState("");
  const [ordenDeCompra, setOrdenDeCompra] = useState("");
  const [terminos, setTerminos] = useState("");
  const [notas, setNotas] = useState("");
  const [vendedores, setVendedores] = useState([]);
  const [vendedorNombre, setVendedorNombre] = useState("");
  const [vendedorCorreo, setVendedorCorreo] = useState("");
  const [nuevoVendedorNombre, setNuevoVendedorNombre] = useState("");
  const [nuevoVendedorCorreo, setNuevoVendedorCorreo] = useState("");
  const [modalVendedorIsOpen, setModalVendedorIsOpen] = useState(false);
  const [datosSeleccionados, setDatosSeleccionados] = useState([
    {
      id: uuidv4(),
      nombre: "",
      modelo: "",
      unidad: "",
      cantidad: 1,
      tarifa: 0,
      iva: 0,
      descuento: 0, // Nuevo campo
      tipoDescuento: "%", // Nuevo campo
      importe: 0,
    },
  ]);
  const [descuento, setDescuento] = useState(0);
  const [productosSeleccionados, setProductosSeleccionados] = useState([]);
  const [mostrarTabla] = useState(false);
  const [setMostrarPrevia] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [filteredProductos, setFilteredProductos] = useState([]);
  const [modoEdicion, setModoEdicion] = useState(false);
  const [formDirty, setFormDirty] = useState(false);
  const [archivos, setArchivos] = useState([]);
  const [modalConfigIsOpen, setModalConfigIsOpen] = useState(false);
  const [prefijo, setPrefijo] = useState("ICR-");
  const [siguienteNumero, setSiguienteNumero] = useState("");
  const [modoNumeroReporte, setModoNumeroReporte] = useState("auto"); // Valores: "auto" o "manual"
  const [activeRow, setActiveRow] = useState(null);
  const [cargandoArchivos, setCargandoArchivos] = useState(false);

  useEffect(() => {
    console.log("Productos seleccionados:", productosSeleccionados);
  }, [productosSeleccionados]);

  useEffect(() => {
    if (editingReport) {
      setModoEdicion(true);
      setNumeroReporte(editingReport.numeroReporte || "");
      setCliente(editingReport.cliente || "");
      setReferencia(editingReport.referencia || "");
      setFechaReporte(
        editingReport.fechaReporte
          ? new Date(editingReport.fechaReporte)
          : new Date()
      );
      setOrdenDeCompra(editingReport.ordenDeCompra || "");
      setUsuario(editingReport.usuario || "");
      setPlanta(editingReport.planta || "");
      setDivisa(editingReport.divisa || "MXN");
      setArea(editingReport.area || "");
      setAsunto(editingReport.asunto || "");
      setTerminos(editingReport.terminos || "");
      setNotas(editingReport.notas || "");
      setVendedorNombre(editingReport.vendedorNombre || "");
      setVendedorCorreo(editingReport.vendedorCorreo || "");
      // Precargar la tabla de productos
      setDatosSeleccionados(
        editingReport.productosSeleccionados
          ? editingReport.productosSeleccionados.map((producto) => ({
              id: uuidv4(), // Genera un nuevo ID para cada fila si es necesario
              ...producto,
              numeroDeParteCliente: producto.numeroDeParteCliente || "",
              nombre: producto.nombre || "",
              unidad: producto.unidad || "",
              cantidad: producto.cantidad || 1,
              tarifa: producto.tarifa || 0,
              iva: producto.iva || 0,
              importe: producto.importe || 0,
            }))
          : []
      );
      setProductosSeleccionados(editingReport.productosSeleccionados || []);
      setDescuento(parseFloat(editingReport.descuento) || 0);
      // **PRECARGAR LOS ARCHIVOS**
      setArchivos(editingReport.archivos || []);
    } else {
      // Reiniciar los campos si no estamos editando
      setOrdenDeCompra("");
      setUsuario("");
      setNumeroReporte("");
      setCliente("");
      setReferencia("");
      setFechaReporte(new Date());
      setPlanta("");
      setDivisa("MXN");
      setArea("");
      setAsunto("");
      setTerminos("");
      setNotas("");
      setVendedorNombre("");
      setVendedorCorreo("");
      setDatosSeleccionados([
        {
          id: uuidv4(),
          nombre: "",
          modelo: "",
          unidad: "",
          cantidad: 1,
          tarifa: 0,
          iva: 0.16,
          descuento: 0,
          tipoDescuento: "%",
          importe: 0,
        },
      ]);
      setProductosSeleccionados([]);
      setDescuento(0);
      // Reiniciar archivos
      setArchivos([]);
    }
  }, [editingReport, prefijo, siguienteNumero]);

  useEffect(() => {
    const fetchProductos = async () => {
      try {
        const productosSnapshot = await getDocs(collection(db, "productos"));
        const productosList = productosSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        console.log("Productos cargados:", productosList); // Verifica los productos cargados
        setProductos(productosList);
      } catch (error) {
        console.error("Error al cargar los productos desde Firestore:", error);
      }
    };

    fetchProductos();
  }, []);

  useEffect(() => {
    const fetchClientes = async () => {
      try {
        const firestore = getFirestore();
        const clientesSnapshot = await getDocs(
          collection(firestore, "clientes")
        );
        const clientesList = clientesSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        // Filtrar clientes únicos basados en el campo "empresa"
        const clientesUnicos = clientesList.filter(
          (cliente, index, self) =>
            index === self.findIndex((c) => c.empresa === cliente.empresa)
        );
        setClientes(clientesUnicos);
      } catch (error) {
        console.error("Error al cargar clientes:", error);
      }
    };

    fetchClientes();
  }, []);

  const subirArchivosYObtenerURLs = async (nuevosArchivos) => {
    const storage = getStorage();
    const urlsArchivos = [];

    for (const archivo of nuevosArchivos) {
      const archivoRef = ref(storage, `obras/${archivo.name}`);
      await uploadBytes(archivoRef, archivo); // Sube el archivo al almacenamiento
      const url = await getDownloadURL(archivoRef); // Obtén la URL de descarga
      urlsArchivos.push(url);
    }

    return urlsArchivos;
  };

  const manejarArchivos = async (event) => {
    const nuevosArchivos = Array.from(event.target.files);

    // Filtrar archivos duplicados
    const archivosSinDuplicados = nuevosArchivos.filter(
      (archivo) => !archivos.some((a) => a.nombre === archivo.name)
    );

    if (archivosSinDuplicados.length === 0) {
      Swal.fire({
        icon: "info",
        title: "Archivos duplicados",
        text: "Los archivos ya están agregados.",
      });
      return;
    }

    // Verifica si se excede el límite de 10 archivos
    const totalArchivos = archivos.length + archivosSinDuplicados.length;
    if (totalArchivos > 10) {
      Swal.fire({
        icon: "error",
        title: "Se excedió el número de archivos",
        text: "Solo se permiten un máximo de 10 archivos.",
      });
      return;
    }

    // Mostrar mensaje de cargando
    setCargandoArchivos(true);

    try {
      // Subir archivos y obtener URLs
      const urlsNuevas = await subirArchivosYObtenerURLs(archivosSinDuplicados);

      // Actualiza el estado con los nuevos archivos (sin duplicados)
      setArchivos((prevArchivos) => [
        ...prevArchivos,
        ...urlsNuevas.map((url, index) => ({
          nombre: archivosSinDuplicados[index].name,
          url,
        })),
      ]);
    } catch (error) {
      console.error("Error al cargar archivos:", error);
      Swal.fire({
        icon: "error",
        title: "Error al cargar archivos",
        text: "Ocurrió un error al cargar los archivos. Por favor, inténtalo de nuevo.",
      });
    } finally {
      // Ocultar mensaje de cargando
      setCargandoArchivos(false);
    }

    setFormDirty(true);
  };

  const handleDescargarArchivo = (url, nombre) => {
    try {
      const link = document.createElement("a");
      link.href = url;
      link.download = nombre; // Establecer nombre para la descarga
      link.target = "_blank"; // Forzar la descarga en lugar de abrir en otra pestaña
      link.rel = "noopener noreferrer"; // Agrega seguridad adicional
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // Limpiar el DOM después de la descarga
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error al descargar",
        text: `No se pudo descargar el archivo ${nombre}.`,
      });
      console.error("Error al descargar el archivo:", error);
    }
  };

  const calcularIVA = () => {
    const subtotalConDescuento = calcularSubtotalConDescuento();
    return subtotalConDescuento > 0 ? subtotalConDescuento * obtenerIVA() : 0;
  };

  const calcularSubtotalConDescuento = () => {
    const subtotal = calcularSubtotal();
    return subtotal > 0 ? subtotal - (subtotal * descuento) / 100 : 0;
  };

  const calcularTotal = () => {
    const subtotalConDescuento = calcularSubtotalConDescuento();
    const ivaCalculado = calcularIVA();
    return subtotalConDescuento + ivaCalculado;
  };

  const obtenerIVA = () => {
    // Valor predeterminado de IVA
    const VALOR_IVA_DEFAULT = 0.16;

    // Retornar el IVA del primer elemento si está disponible; de lo contrario, usar el predeterminado
    if (datosSeleccionados.length > 0 && datosSeleccionados[0]?.iva) {
      return datosSeleccionados[0].iva;
    }

    return VALOR_IVA_DEFAULT;
  };

  const calcularSubtotal = () => {
    if (!datosSeleccionados || datosSeleccionados.length === 0) return 0;

    return datosSeleccionados.reduce((total, producto) => {
      const tarifa = parseFloat(producto.tarifa) || 0;
      const cantidad = parseInt(producto.cantidad) || 0;
      const descuento = parseFloat(producto.descuento) || 0;

      const descuentoAplicado =
        producto.tipoDescuento === "%"
          ? tarifa * cantidad * (descuento / 100)
          : descuento;

      return total + tarifa * cantidad - descuentoAplicado;
    }, 0);
  };

  const agregarArticulosAGranel = (articulos) => {
    // Lógica para agregar artículos a granel
    console.log("Agregando artículos a granel:", articulos);
  };

  const añadirFila = (e) => {
    e.preventDefault(); // Evita el comportamiento por defecto del botón
    const nuevaFila = {
      id: uuidv4(),
      nombre: "",
      numeroDeParteCliente: "",
      cantidad: 1,
      tarifa: 0,
      iva: 0.16, // Asegura que el IVA tenga un valor predeterminado
      descuento: 0, // Asegura que el descuento tenga un valor inicial
      tipoDescuento: "%", // Tipo de descuento inicial
      importe: 0, // Importe inicial en 0
    };

    setDatosSeleccionados((prevDatos) => [...prevDatos, nuevaFila]);
  };

  const eliminarProducto = (id) => {
    setDatosSeleccionados((prevDatos) => {
      const nuevosDatos = prevDatos.filter((producto) => producto.id !== id);
      return nuevosDatos.length > 0 ? nuevosDatos : [];
    });
  };

  const actualizarCantidad = (productoId, nuevaCantidad) => {
    setDatosSeleccionados((prevDatos) =>
      prevDatos.map((item) =>
        item.id === productoId
          ? {
              ...item,
              cantidad: nuevaCantidad,
              importe: item.tarifa * nuevaCantidad, // Solo calcula el importe sin aplicar IVA aquí
            }
          : item
      )
    );
  };

  const eliminarArchivo = (nombreArchivo) => {
    Swal.fire({
      title: "¿Eliminar archivo?",
      text: `El archivo ${nombreArchivo} será eliminado.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        setArchivos((prevArchivos) =>
          prevArchivos.filter((archivo) => archivo.nombre !== nombreArchivo)
        );
        Swal.fire("¡Eliminado!", "El archivo ha sido eliminado.", "success");
      }
    });
  };

  const handleInputChange = (e, productoId) => {
    const inputValue = e.target.value;
    setFormDirty(true); // Marcar que el formulario ha sido modificado

    // Filtrar productos según el texto ingresado
    const productosFiltrados = productos.filter((prod) =>
      prod.nombre.toLowerCase().includes(inputValue.toLowerCase())
    );
    setFilteredProductos(productosFiltrados);

    // Actualizar la fila activa para mostrar el listado solo en el campo correspondiente
    setActiveRow(productoId); // Agregar esta línea para asociar la fila activa

    // Encuentra el producto en la lista de productos reales desde Firestore
    const productoEncontrado = productos.find(
      (prod) => prod.nombre.toLowerCase() === inputValue.toLowerCase()
    );

    if (productoEncontrado) {
      setDatosSeleccionados((prevDatos) => {
        // Verifica si el producto ya existe en otra fila distinta a la que se está editando
        const existingItem = prevDatos.find(
          (item) =>
            item.nombre === productoEncontrado.nombre && item.id !== productoId
        );

        if (existingItem) {
          // Si el producto ya existe, sumamos las cantidades
          const currentItem = prevDatos.find((item) => item.id === productoId);
          const nuevaCantidad =
            (existingItem.cantidad || 0) + (currentItem.cantidad || 1);

          // Actualizamos el producto existente con la nueva cantidad e importe
          const nuevosDatos = prevDatos.map((item) => {
            if (item.id === existingItem.id) {
              return {
                ...item,
                cantidad: nuevaCantidad,
                importe: productoEncontrado.costo * nuevaCantidad,
              };
            }
            return item;
          });

          // Eliminamos la fila actual (para no duplicar)
          return nuevosDatos.filter((item) => item.id !== productoId);
        } else {
          // Si el producto no existe en otra fila, simplemente actualizamos la fila actual
          return prevDatos.map((item) =>
            item.id === productoId
              ? {
                  ...item,
                  nombre: productoEncontrado.nombre,
                  descripcion: productoEncontrado["Item Desc"] || "",
                  numeroDeParteCliente: productoEncontrado.numeroDeParteCliente,
                  tarifa: productoEncontrado.costo,
                  iva: 0.16,
                  importe: productoEncontrado.costo * item.cantidad,
                }
              : item
          );
        }
      });
    } else {
      // Producto ingresado manualmente (no encontrado en Firestore)
      setDatosSeleccionados((prevDatos) =>
        prevDatos.map((item) =>
          item.id === productoId
            ? { ...item, nombre: inputValue, descripcion: inputValue }
            : item
        )
      );
    }
  };

  // Ejemplo de handleFileChange sin base64
  const handleFileChange = async (e, productoId) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      // Obtén la referencia a Storage
      const storage = getStorage();
      // Puedes agregar un identificador único al nombre si lo necesitas:
      const fileName = `${Date.now()}_${file.name}`;
      const archivoRef = ref(storage, `productos/${fileName}`);

      // Sube el archivo
      await uploadBytes(archivoRef, file);

      // Obtén la URL de descarga
      const url = await getDownloadURL(archivoRef);

      // Guarda SOLO la URL en el objeto del producto
      setDatosSeleccionados((prevDatos) =>
        prevDatos.map((item) =>
          item.id === productoId ? { ...item, imagenUrl: url } : item
        )
      );
    } catch (err) {
      console.error("Error subiendo la imagen", err);
      Swal.fire({
        icon: "error",
        title: "Error al subir la imagen",
        text: err.message,
      });
    }
  };

  const handleAgregarVendedor = () => {
    if (nuevoVendedorNombre.trim() !== "") {
      guardarVendedorEnFirestore(nuevoVendedorNombre, nuevoVendedorCorreo); // Guarda el vendedor en Firestore
      setVendedorNombre(nuevoVendedorNombre); // Actualiza el nombre del vendedor seleccionado
      setVendedorCorreo(nuevoVendedorCorreo); // Actualiza el correo del vendedor seleccionado
      closeModalVendedor(); // Cierra el modal después de guardar
    } else {
      Swal.fire({
        icon: "error",
        title: "Nombre requerido",
        text: "El nombre del vendedor no puede estar vacío.",
      });
    }
  };

  const guardarVendedorEnFirestore = async (nombre, correo) => {
    try {
      const vendedorData = {
        nombre,
        correo,
        registrado: true,
        creadoEn: serverTimestamp(),
      };
      await addDoc(collection(db, "vendedores"), vendedorData);
      Swal.fire({
        icon: "success",
        title: "Vendedor guardado correctamente",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (error) {
      console.error("Error al guardar vendedor en Firestore:", error);
      Swal.fire({
        icon: "error",
        title: "Error al guardar vendedor",
        text: error.message,
      });
    }
  };

  useEffect(() => {
    const cargarVendedores = () => {
      const vendedoresRef = collection(db, "vendedores");
      const unsubscribe = onSnapshot(vendedoresRef, (snapshot) => {
        const vendedoresList = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setVendedores(vendedoresList);
      });

      return () => unsubscribe(); // Limpia el listener al desmontar el componente
    };

    cargarVendedores();
  }, []);

  const openModalVendedor = () => {
    if (vendedorNombre && vendedorNombre !== "agregar-nuevo") {
      // Editar vendedor existente
      setNuevoVendedorNombre(vendedorNombre);
      setNuevoVendedorCorreo(vendedorCorreo);
    } else {
      // Agregar nuevo vendedor
      setNuevoVendedorNombre("");
      setNuevoVendedorCorreo("");
    }
    setModalVendedorIsOpen(true);
  };

  const closeModalVendedor = () => {
    setModalVendedorIsOpen(false);
    setNuevoVendedorNombre("");
    setNuevoVendedorCorreo("");
  };

  const obtenerIconoArchivo = (extension) => {
    switch (extension) {
      case "xls":
      case "xlsx":
      case "csv":
        return { icon: "bi-file-earmark-excel", color: "green" };
      case "doc":
      case "docx":
        return { icon: "bi-file-earmark-word", color: "blue" };
      case "pdf":
        return { icon: "bi-file-earmark-pdf", color: "red" };
      case "jpg":
      case "jpeg":
      case "png":
      case "svg":
        return { icon: "bi-image", color: "blue" };
      default:
        return { icon: "bi-file-earmark", color: "gray" }; // Ícono genérico
    }
  };

  const guardar = async (e) => {
    e.preventDefault();

    if (!cliente || !numeroReporte || !fechaReporte || !ordenDeCompra) {
      Swal.fire({
        icon: "error",
        title: "Campos obligatorios faltantes",
        text: "Por favor completa los campos: Nombre del cliente, No. Reporte, Fecha de reporte y Atención.",
      });
      return;
    }

    try {
      if (modoEdicion && editingReport?.id) {
        await updateDoc(doc(db, "obras", editingReport.id), {
          ordenDeCompra,
          usuario,
          cliente,
          numeroReporte, // Mantiene el mismo número de reporte
          nombreCliente: clientes.find((c) => c.id === cliente)?.empresa || "",
          referencia,
          fechaReporte: fechaReporte ? fechaReporte.toISOString() : null,
          vendedorNombre,
          vendedorCorreo,
          planta,
          area,
          divisa,
          asunto,
          productosSeleccionados: datosSeleccionados,
          total: calcularTotal(),
          notas,
          terminos,
          descuento,
          updatedAt: serverTimestamp(),
          estado: "Pendiente",
          archivos,
        });

        Swal.fire({
          icon: "success",
          title: "Reporte actualizado correctamente",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          setFormDirty(false);
          window.location.reload();
        });
      } else {
        // Crear nuevo reporte
        const nuevoNumeroReporte =
          modoNumeroReporte === "auto"
            ? `${prefijo}${String(siguienteNumero).padStart(4, "0")}`
            : numeroReporte;

        const reporteData = {
          ordenDeCompra,
          usuario,
          cliente,
          numeroReporte: nuevoNumeroReporte,
          nombreCliente: clientes.find((c) => c.id === cliente)?.empresa || "",
          referencia,
          fechaReporte: fechaReporte ? fechaReporte.toISOString() : null,
          vendedorNombre,
          vendedorCorreo,
          planta,
          area,
          divisa,
          asunto,
          productosSeleccionados: datosSeleccionados,
          total: calcularTotal(),
          notas,
          terminos,
          descuento,
          createdAt: serverTimestamp(),
          estado: "Pendiente",
          archivos,
        };

        const docRef = await addDoc(collection(db, "obras"), reporteData);
        console.log("Nuevo reporte guardado con ID:", docRef.id);

        // Agregar el nuevo reporte a la lista de reportes sin recargar la página
        setReportes((prev) => [{ id: docRef.id, ...reporteData }, ...prev]);

        if (modoNumeroReporte === "auto") {
          await actualizarNumeroReporte(parseInt(siguienteNumero, 10) + 1);
        }

        Swal.fire({
          icon: "success",
          title: "Reporte Guardado",
          text: "Tu reporte se guardó exitosamente",
          confirmButtonText: "Ok",
        }).then(() => {
          setFormDirty(false);
          window.location.reload();
        });
      }
    } catch (error) {
      console.error("Error al guardar el reporte:", error);
      Swal.fire({
        icon: "error",
        title: "Error al guardar el reporte",
        text: error.message,
      });
    }
  };

  const handleCancel = () => {
    if (formDirty) {
      Swal.fire({
        title: "¿Seguro que quieres salir?",
        text: "Se perderán los cambios realizados",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, salir",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          // Cerrar el modal usando la función pasada como prop
          //closeModal();
          setFormDirty(false); // Opcional: resetea el estado si es necesario
        }
      });
    } else {
      // Si no hay cambios, simplemente cierra el modal
      //closeModal();
    }
  };

  const handleModoCambio = (e) => {
    const nuevoModo = e.target.value;
    setModoNumeroReporte(nuevoModo);

    if (nuevoModo === "auto") {
      setNumeroReporte(`${prefijo}${siguienteNumero}`);
      // Alerta para modo automático
      Swal.fire({
        icon: "success",
        title: "Modo Automático Activado",
        text: "Ahora los números de reportes se actualizarán automáticamente.",
        confirmButtonText: "Entendido",
      });
    } else {
      setNumeroReporte(""); // Permitir al usuario escribir manualmente
      // Alerta para modo manual
      Swal.fire({
        icon: "info",
        title: "Modo Manual Activado",
        text: "Ahora puedes agregar manualmente un número de reporte.",
        confirmButtonText: "Entendido",
      });
    }
  };

  useEffect(() => {
    if (!editingReport) {
      const numeroFormateado = String(siguienteNumero).padStart(4, "0");
      setNumeroReporte(`${prefijo}${numeroFormateado}`);
    }
  }, [siguienteNumero, prefijo, editingReport]);

  const actualizarNumeroReporte = async (nuevoNumero) => {
    try {
      const docRef = doc(db, "configuracion", "numeroReporte"); // Mismo documento
      await setDoc(
        docRef,
        { prefijo, siguienteNumero: nuevoNumero },
        { merge: true }
      );
    } catch (error) {
      console.error("Error al actualizar número de cotización:", error);
    }
  };

  const guardarConfiguracionNumeroReporte = async () => {
    try {
      // Usar actualizarNumeroReporte para actualizar el documento "numeroReporte"
      await actualizarNumeroReporte(parseInt(siguienteNumero, 10));
      // Después de guardar, volver a cargar la configuración desde Firestore
      await fetchNumeroReporte();
      setModalConfigIsOpen(false);
      Swal.fire({
        icon: "success",
        title: "Configuración actualizada",
        text: "La configuración del número de cotización se ha actualizado correctamente.",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error al guardar configuración:", error);
      Swal.fire({
        icon: "error",
        title: "Error al guardar",
        text: "Hubo un problema al guardar la configuración. Por favor, inténtalo de nuevo.",
      });
    }
  };

  const fetchNumeroReporte = async () => {
    try {
      const docRef = doc(db, "configuracion", "numeroReporte");
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        setPrefijo(data.prefijo || "IC-");
        setSiguienteNumero(data.siguienteNumero || ""); // Usar un valor predeterminado lógico
      } else {
        // Si no existe, inicializa con valores predeterminados
        await setDoc(docRef, { prefijo: "IC-", siguienteNumero: "" });
        setPrefijo("IC-");
        setSiguienteNumero("");
      }
    } catch (error) {
      console.error("Error al obtener número de cotización:", error);
    }
  };

  useEffect(() => {
    fetchNumeroReporte();
  }, []);

  const cerrarModalPrevia = () => {
    setMostrarPrevia(false);
    setModalIsOpen(false);
  };

  return (
    <>
      <Nav
        proximasAVencer={proximasAVencer}
        proximosEventos={proximosEventos}
      />

      <Sidebar />

      <div className="cotizacion-form">
        <form
          onKeyDown={(e) => {
            // Solo bloquear "Enter" fuera de los elementos <textarea>
            if (e.key === "Enter" && e.target.tagName !== "TEXTAREA") {
              e.preventDefault();
            }
          }}
        >
          <div>
            <div className="group apartado">
              <label htmlFor="cliente" className="required">
                Razón Social*
              </label>
              <select
                id="cliente"
                name="cliente"
                value={cliente}
                onChange={(e) => {
                  setCliente(e.target.value);
                  setFormDirty(true); // Marcar que el formulario ha sido modificado
                }}
              >
                <option value="">Seleccionar cliente</option>
                {clientes
                  .slice() // Crea una copia para evitar modificar el estado original
                  .sort((a, b) => a.empresa.localeCompare(b.empresa)) // Ordenar alfabéticamente
                  .map((cliente) => (
                    <option key={cliente.id} value={cliente.id}>
                      {cliente.empresa}
                    </option>
                  ))}
              </select>
            </div>

            <br />

            <div className="group">
              <label htmlFor="numeroReporte" className="required">
                No. Reporte#*
              </label>
              <div className="input-wrapper">
                <input
                  type="text"
                  id="numeroReporte"
                  name="numeroReporte"
                  value={numeroReporte}
                  onChange={(e) => {
                    if (modoNumeroReporte === "manual") {
                      setNumeroReporte(e.target.value);
                    }
                  }}
                  disabled={modoNumeroReporte === "auto"} // Deshabilitar en modo automático
                />
                <button
                  type="button"
                  className="icon-button"
                  onClick={() => setModalConfigIsOpen(true)}
                >
                  <i className="bi bi-gear-fill"></i>
                </button>
              </div>
            </div>

            <div className="group fechas">
              <div className="group">
                <label htmlFor="referencia">Referencia</label>
                <input
                  type="text"
                  id="referencia"
                  name="referencia"
                  value={referencia}
                  onChange={(e) => {
                    setReferencia(e.target.value);
                    setFormDirty(true); // Marcar que el formulario ha sido modificado
                  }}
                />
              </div>

              <div className="group">
                <label htmlFor="ordenDeCompra" className="required">
                  Orden de Compra*
                </label>
                <input
                  type="text"
                  id="ordenDeCompra"
                  name="ordenDeCompra"
                  value={ordenDeCompra}
                  onChange={(e) => {
                    setOrdenDeCompra(e.target.value);
                    setFormDirty(true); // Marcar que el formulario ha sido modificado
                  }}
                />
              </div>
            </div>

            <div className="group fechas">
              <div className="group">
                <label htmlFor="fecha-reporte" className="required">
                  Fecha de Reporte*
                </label>
                <DatePicker
                  selected={fechaReporte}
                  onChange={(date) => {
                    setFechaReporte(date);
                    setFormDirty(true); // Marcar el formulario como modificado
                  }}
                  dateFormat="dd MMM yyyy"
                  placeholderText="dd MMM yyyy"
                  id="fecha-cotizacion"
                  locale="es"
                />
              </div>
            </div>

            <hr
              style={{
                marginBottom: "30px",
                marginTop: "20px",
                border: "1px solid #f9f9fb",
              }}
            />

            <div className="group fechas">
              <div className="group">
                <label htmlFor="vendedorNombre">Vendedor</label>
                <select
                  style={{ width: "42%" }}
                  id="vendedorNombre"
                  name="vendedorNombre"
                  value={
                    vendedores.find((v) => v.nombre === vendedorNombre)?.id ||
                    ""
                  }
                  onChange={(e) => {
                    const selectedValue = e.target.value;

                    if (selectedValue === "agregar-nuevo") {
                      openModalVendedor(); // Abre el modal para agregar un nuevo vendedor
                    } else {
                      const vendedorSeleccionado = vendedores.find(
                        (vendedor) => vendedor.id === selectedValue
                      );
                      if (vendedorSeleccionado) {
                        setVendedorNombre(vendedorSeleccionado.nombre);
                        setVendedorCorreo(vendedorSeleccionado.correo);
                      }
                    }
                  }}
                >
                  <option value="">Seleccionar vendedor</option>
                  {vendedores.map((vendedor) => (
                    <option key={vendedor.id} value={vendedor.id}>
                      {vendedor.nombre}
                    </option>
                  ))}
                  <option key="agregar-nuevo" value="agregar-nuevo">
                    Agregar nuevo vendedor
                  </option>
                </select>

                <br />

                {/* Modal para agregar o editar vendedor */}
                <Modal
                  isOpen={modalVendedorIsOpen}
                  onRequestClose={closeModalVendedor}
                  contentLabel="Agregar o Editar Vendedor"
                  style={customStyles2}
                >
                  <h2 style={customStyles2.h2}>Agregar Nuevo Vendedor</h2>
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleAgregarVendedor();
                    }}
                    style={customStyles2.form}
                  >
                    <label
                      htmlFor="nuevoVendedorNombre"
                      style={customStyles2.label}
                    >
                      Nombre (obligatorio)
                    </label>
                    <input
                      type="text"
                      id="nuevoVendedorNombre"
                      name="nuevoVendedorNombre"
                      value={nuevoVendedorNombre}
                      onChange={(e) => setNuevoVendedorNombre(e.target.value)}
                      required
                      style={customStyles2.input}
                    />
                    <br />
                    <label
                      htmlFor="nuevoVendedorCorreo"
                      style={customStyles2.label}
                    >
                      Correo
                    </label>
                    <input
                      type="email"
                      id="nuevoVendedorCorreo"
                      name="nuevoVendedorCorreo"
                      value={nuevoVendedorCorreo}
                      onChange={(e) => setNuevoVendedorCorreo(e.target.value)}
                      style={customStyles2.input}
                    />
                    <br />
                    <div style={customStyles2.buttonContainer}>
                      <button
                        type="button"
                        onClick={closeModalVendedor}
                        style={{
                          ...customStyles2.button,
                          ...customStyles2.buttonCancel,
                        }}
                      >
                        Cancelar
                      </button>
                      <button type="submit" style={customStyles2.button}>
                        Guardar
                      </button>
                    </div>
                  </form>
                </Modal>
              </div>

              <div className="group">
                <label htmlFor="usuario">Usuario</label>
                <input
                  type="text"
                  id="usuario"
                  name="usuario"
                  value={usuario}
                  onChange={(e) => {
                    setUsuario(e.target.value);
                    setFormDirty(true); // Marcar el formulario como modificado
                  }}
                />
              </div>
            </div>

            <div className="group">
              <label htmlFor="planta">Planta</label>
              <input
                type="text"
                id="planta"
                name="planta"
                value={planta}
                onChange={(e) => {
                  setPlanta(e.target.value);
                  setFormDirty(true); // Marcar el formulario como modificado
                }}
              />
            </div>

            <div className="group fechas">
              <div className="group">
                <label htmlFor="area">Área</label>
                <input
                  type="text"
                  id="area"
                  name="area"
                  value={area}
                  onChange={(e) => {
                    setArea(e.target.value);
                    setFormDirty(true); // Marcar el formulario como modificado
                  }}
                />
              </div>
              <div className="group">
                <label htmlFor="divisa">Divisa</label>
                <select
                  id="divisa"
                  name="divisa"
                  value={divisa}
                  onChange={(e) => {
                    setDivisa(e.target.value);
                    setFormDirty(true); // Marcar el formulario como modificado
                  }}
                >
                  <option value="MXN">MXN</option>
                  <option value="USD">USD</option>
                </select>
              </div>
            </div>

            <br />

            <div className="group">
              <label htmlFor="asunto">Asunto</label>
              <input
                type="text"
                id="asunto"
                name="asunto"
                value={asunto}
                onChange={(e) => {
                  setAsunto(e.target.value);
                  setFormDirty(true); // Marcar el formulario como modificado
                }}
              />
            </div>

            <br />

            <div className="apartado2">Tabla de productos</div>

            <div>
              {/* Contenedor para la tabla y los botones */}
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  width: "95%",
                }}
              >
                {/* Tabla general */}
                <div>
                  <table className="productos-table">
                    <thead>
                      <tr>
                        <th>Detalles del Artículo</th>
                        <th style={{ textAlign: "center" }}>Modelo</th>
                        <th id="unidad-col">UNIDAD</th>
                        <th id="cantidad-col">Cantidad</th>
                        <th id="precio-col">Precio</th>
                        <th id="importe-col">Importe</th>
                        <th id="instalada-col">Cant. instalada</th>
                        <th id="avance-col">Avance %</th>
                        <th id="imagen-col">Imagen</th>
                      </tr>
                    </thead>
                    <tbody>
                      {datosSeleccionados.map((producto) => (
                        <tr key={producto.id} style={{ position: "relative" }}>
                          {/* Detalles del Artículo */}
                          <td>
                            <div style={{ position: "relative" }}>
                              <textarea
                                className="list-products"
                                value={
                                  producto.descripcion || producto.nombre || ""
                                }
                                onChange={(e) =>
                                  handleInputChange(e, producto.id)
                                }
                                onBlur={() =>
                                  setTimeout(
                                    () => setFilteredProductos([]),
                                    100
                                  )
                                }
                                placeholder="Escriba para seleccionar un artículo"
                                style={{
                                  width: "400px",
                                  height: "130px",
                                  padding: "8px",
                                  fontSize: "14px",
                                  lineHeight: "1.5",
                                  resize: "vertical",
                                  overflow: "auto",
                                  whiteSpace: "pre-wrap",
                                  fontFamily: "Arial, sans-serif",
                                }}
                              />
                              {activeRow === producto.id &&
                                filteredProductos.length > 0 && (
                                  <ul
                                    style={{
                                      position: "absolute",
                                      top: "105%",
                                      left: 0,
                                      width: "100%",
                                      backgroundColor: "#fff",
                                      border: "1px solid #cecece",
                                      borderRadius: "5px",
                                      zIndex: 10,
                                      maxHeight: "150px",
                                      overflowY: "auto",
                                      listStyle: "none",
                                      padding: "5px",
                                      margin: 0,
                                    }}
                                  >
                                    {filteredProductos.map((prod) => (
                                      <li
                                        key={prod.id}
                                        onMouseDown={() => {
                                          handleInputChange(
                                            { target: { value: prod.nombre } },
                                            producto.id
                                          );
                                          setFormDirty(true);
                                        }}
                                        style={{
                                          padding: "5px",
                                          cursor: "pointer",
                                          backgroundColor: "#f9f9f9",
                                          marginBottom: "2px",
                                        }}
                                      >
                                        {prod.nombre}
                                      </li>
                                    ))}
                                  </ul>
                                )}
                            </div>
                          </td>
                          {/* Modelo */}
                          <td>
                            <input
                              type="text"
                              value={
                                producto.modelo ||
                                producto.numeroDeParteCliente ||
                                ""
                              }
                              onChange={(e) => {
                                const nuevoModelo = e.target.value;
                                setDatosSeleccionados((prevDatos) =>
                                  prevDatos.map((item) =>
                                    item.id === producto.id
                                      ? { ...item, modelo: nuevoModelo }
                                      : item
                                  )
                                );
                                setFormDirty(true);
                              }}
                            />
                          </td>
                          {/* Unidad */}
                          <td>
                            <select
                              value={producto.unidad || ""}
                              onChange={(e) => {
                                const nuevaUnidad = e.target.value;
                                setDatosSeleccionados((prevDatos) =>
                                  prevDatos.map((item) =>
                                    item.id === producto.id
                                      ? { ...item, unidad: nuevaUnidad }
                                      : item
                                  )
                                );
                                setFormDirty(true); // Si quieres marcar que el formulario se ha modificado
                              }}
                            >
                              <option value="">Seleccionar</option>
                              <option value="pieza">Pieza</option>
                              <option value="servicio">Servicio</option>
                              <option value="kit">Kit</option>
                              <option value="metro">Metro</option>
                            </select>
                          </td>

                          {/* Cantidad */}
                          <td id="cantidad-col">
                            <input
                              type="number"
                              value={producto.cantidad || 1}
                              onChange={(e) => {
                                actualizarCantidad(
                                  producto.id,
                                  parseInt(e.target.value, 10) || 0
                                );
                                setFormDirty(true);
                              }}
                            />
                          </td>
                          {/* Precio */}
                          <td id="precio-col">
                            <input
                              type="text"
                              value={
                                producto.tarifa !== undefined &&
                                producto.tarifa !== ""
                                  ? producto.tarifa.toString()
                                  : ""
                              }
                              onFocus={(e) => {
                                const valorActual =
                                  parseFloat(producto.tarifa) || "";
                                e.target.value = valorActual;
                              }}
                              onChange={(e) => {
                                const nuevoValor = e.target.value.replace(
                                  /[^0-9.]/g,
                                  ""
                                );
                                if (/^\d*\.?\d*$/.test(nuevoValor)) {
                                  const valorNumerico =
                                    parseFloat(nuevoValor) || 0;
                                  setDatosSeleccionados((prevDatos) =>
                                    prevDatos.map((item) =>
                                      item.id === producto.id
                                        ? {
                                            ...item,
                                            tarifa: nuevoValor,
                                            importe:
                                              valorNumerico *
                                              (item.cantidad || 0),
                                          }
                                        : item
                                    )
                                  );
                                  setFormDirty(true);
                                }
                              }}
                              onBlur={(e) => {
                                const valorNumerico = parseFloat(
                                  e.target.value
                                );
                                if (!isNaN(valorNumerico)) {
                                  const valorFormateado =
                                    valorNumerico.toLocaleString("en-US", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    });
                                  setDatosSeleccionados((prevDatos) =>
                                    prevDatos.map((item) =>
                                      item.id === producto.id
                                        ? {
                                            ...item,
                                            tarifa: valorNumerico,
                                            importe:
                                              valorNumerico *
                                              (item.cantidad || 0),
                                          }
                                        : item
                                    )
                                  );
                                  e.target.value = valorFormateado;
                                }
                              }}
                              style={{
                                width: "100%",
                                textAlign: "right",
                                padding: "8px",
                                fontSize: "14px",
                                borderRadius: "4px",
                              }}
                            />
                          </td>
                          {/* Importe */}
                          <td
                            id="importe-col"
                            style={{
                              textAlign: "right",
                              paddingRight: "10px",
                            }}
                          >
                            $
                            {parseFloat(producto.importe || 0).toLocaleString(
                              "en-US",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </td>
                          {/* Nuevas columnas */}
                          {/* Cantidad instalada */}
                          <td>
                            <input
                              type="number"
                              placeholder="Instalada"
                              value={producto.cantidadInstalada || ""}
                              onChange={(e) => {
                                const value = parseInt(e.target.value, 10) || 0;
                                setDatosSeleccionados((prev) =>
                                  prev.map((item) =>
                                    item.id === producto.id
                                      ? { ...item, cantidadInstalada: value }
                                      : item
                                  )
                                );
                              }}
                              style={{ width: "100%", textAlign: "center" }}
                            />
                          </td>
                          {/* Avance % */}
                          <td>
                            <input
                              type="number"
                              placeholder="Avance %"
                              value={producto.avance || ""}
                              onChange={(e) => {
                                const value = parseFloat(e.target.value) || 0;
                                setDatosSeleccionados((prev) =>
                                  prev.map((item) =>
                                    item.id === producto.id
                                      ? { ...item, avance: value }
                                      : item
                                  )
                                );
                              }}
                              style={{ width: "100%", textAlign: "center" }}
                            />
                          </td>
                          {/* Imagen */}
                          <td>
                            {producto.imagenUrl ? (
                              <img
                                src={producto.imagenUrl} // <-- Usar la nueva propiedad
                                alt="Producto"
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  objectFit: "contain",
                                  margin: "0 auto",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              />
                            ) : (
                              <div style={{ textAlign: "center" }}>
                                <input
                                  type="file"
                                  id={`fileInput-${producto.id}`}
                                  style={{ display: "none" }}
                                  accept="image/*"
                                  onChange={(e) =>
                                    handleFileChange(e, producto.id)
                                  }
                                />
                                <button
                                  type="button"
                                  onClick={() => {
                                    document
                                      .getElementById(
                                        `fileInput-${producto.id}`
                                      )
                                      .click();
                                  }}
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  Subir imagen
                                </button>
                              </div>
                            )}
                          </td>

                          {/* Botones de acción, respetando la posición original por fuera de la tabla */}
                          <div
                            style={{
                              position: "absolute",
                              right: "-80px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              display: "flex",
                            }}
                          >
                            <button
                              type="button"
                              style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                              }}
                            >
                              <i
                                className="bi bi-three-dots-vertical"
                                style={{ fontSize: "1.2rem" }}
                              ></i>
                            </button>
                            <button
                              type="button"
                              style={{
                                background: "none",
                                border: "none",
                                color: "#dc3545",
                                cursor: "pointer",
                              }}
                              onClick={() => eliminarProducto(producto.id)}
                            >
                              <i
                                className="bi bi-x-lg"
                                style={{ fontSize: "1.2rem" }}
                              ></i>
                            </button>
                          </div>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="acciones-tabla">
              <button type="button" onClick={añadirFila}>
                <i
                  style={{ color: "#007bff", fontSize: "16px" }}
                  className="bi bi-plus-circle-fill"
                ></i>
                Añadir nueva fila
              </button>
              <button type="button" onClick={agregarArticulosAGranel}>
                <i
                  style={{ color: "#007bff", fontSize: "16px" }}
                  className="bi bi-plus-circle-fill"
                ></i>
                Agregar artículos a granel
              </button>
            </div>

            <div className="data-container">
              <div className="notes-container">
                <label htmlFor="customer-notes">Notas</label>
                <textarea
                  id="customer-notes"
                  placeholder="Escribe tus notas aquí..."
                  value={notas}
                  onChange={(e) => {
                    setNotas(e.target.value);
                    setFormDirty(true); // Marcar el formulario como modificado
                  }}
                ></textarea>
              </div>

              <div className="totales-container">
                <div className="row">
                  <span className="label">Subtotal</span>
                  <span>
                    $
                    {calcularSubtotal().toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </div>

                <div className="row iva">
                  <span className="label">
                    IVA [{(obtenerIVA() * 100).toFixed(0)}%]
                  </span>
                  <span>
                    $
                    {(
                      (calcularSubtotal() -
                        calcularSubtotal() * (descuento / 100)) *
                      obtenerIVA()
                    ).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </div>

                <hr />

                <div className="row total">
                  <span>Total ({divisa})</span>
                  <span className="total-amount">
                    $
                    {calcularTotal().toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </div>
              </div>
            </div>

            <div
              style={{
                backgroundColor: "#f9f9fb",
                padding: "8px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: "10px",
                width: "94%",
                marginTop: "30px",
                paddingBottom: "30px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
              {/* Left Section: Términos y Condiciones */}
              <div className="terminos-container">
                <h4>CONDICIONES / OBSERVACIONES</h4>
                <textarea
                  value={terminos}
                  onChange={(e) => {
                    setTerminos(e.target.value);
                    setFormDirty(true); // Marcar el formulario como modificado
                  }}
                />
              </div>

              {/* Right Section: File Upload */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: "8px",
                  flex: "0 0 530px",
                  marginTop: "30px",
                }}
              >
                <label style={{ fontSize: "14px" }}>
                  Adjuntar archivo(s) a Estimación
                </label>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px dashed #ccc",
                    borderRadius: "5px",
                    overflow: "hidden", // Eliminar cualquier contenido que se salga del borde
                  }}
                >
                  <label
                    style={{
                      padding: "8px 10px",
                      backgroundColor: "#fff",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      cursor: "pointer",
                      whiteSpace: "nowrap", // Evitar que el contenido del botón se ajuste en varias líneas
                    }}
                  >
                    <i style={{ color: "#000" }} className="bi bi-upload"></i>
                    <span
                      style={{
                        fontSize: "14px",
                        color: "#000",
                        fontWeight: "lighter",
                      }}
                    >
                      Cargar archivo
                    </span>
                    <input
                      type="file"
                      style={{ display: "none" }} // Ocultar el input de archivo
                      accept=".csv,.xls,.xlsx,.doc,.docx,.pdf,.jpg,.jpeg,.png,.svg,.txt"
                      onChange={manejarArchivos}
                    />
                  </label>

                  <div
                    style={{
                      padding: "10px",
                      backgroundColor: "#fff",
                      borderLeft: "1px dashed #ccc", // Borde que conecta con el input
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      borderTopRightRadius: "auto", // Bordes redondeados en la esquina derecha
                      borderBottomRightRadius: "auto",
                      minWidth: "20px", // Evitar que el botón se haga demasiado pequeño
                      margin: "0", // Eliminar cualquier margen que agregue espacio extra
                    }}
                  >
                    <i
                      style={{
                        color: "#000",
                        fontSize: "14px", // Ajustar el tamaño del ícono
                      }}
                      className="bi bi-chevron-down"
                    ></i>
                  </div>
                </div>

                <p style={{ fontSize: "12px", color: "#888" }}>
                  Puedes cargar un máximo de 10 archivos, cada uno de 10 MB
                </p>

                {cargandoArchivos && (
                  <p style={{ fontSize: "14px", color: "#888" }}>
                    Cargando archivo...
                  </p>
                )}

                {archivos.length > 0 && (
                  <div style={{ width: "100%" }}>
                    <strong>Archivos cargados:</strong>
                    <ul
                      style={{
                        listStyle: "none",
                        padding: 0,
                        marginTop: "10px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                      }}
                    >
                      {archivos.map((archivo, index) => {
                        const extension = archivo.nombre
                          .split(".")
                          .pop()
                          .toLowerCase();
                        const { icon, color } = obtenerIconoArchivo(extension);

                        return (
                          <li
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                              padding: "10px",
                              border: "1px solid #ddd",
                              borderRadius: "5px",
                              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                              backgroundColor: "#f9f9fb",
                            }}
                          >
                            <i
                              className={`bi ${icon}`}
                              style={{
                                color,
                                fontSize: "1.5rem",
                                flexShrink: 0,
                              }}
                            ></i>

                            <span style={{ flexGrow: 1 }}>
                              {archivo.nombre}
                            </span>

                            {/* Botón de descarga */}
                            <button
                              onClick={(e) => {
                                e.preventDefault(); // Evitar el comportamiento predeterminado del botón
                                handleDescargarArchivo(
                                  archivo.url,
                                  archivo.nombre
                                );
                              }}
                              style={{
                                color: "#007bff",
                                background: "none",
                                border: "none",
                                fontWeight: "bold",
                                cursor: "pointer",
                              }}
                            >
                              <i
                                style={{ fontSize: "20px" }}
                                className="bi bi-download"
                              ></i>
                            </button>

                            {/* Botón de eliminar */}
                            <button
                              type="button"
                              onClick={() => eliminarArchivo(archivo.nombre)}
                              style={{
                                border: "none",
                                background: "transparent",
                                color: "#dc3545",
                                cursor: "pointer",
                              }}
                            >
                              <i
                                className="bi bi-trash"
                                style={{ fontSize: "20px" }}
                              ></i>
                            </button>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Grupo de botones: Guardar como borrador, Guardar y enviar, Cancelar */}
          <div className="cotizacion-toolbar">
            <div className="btn-group">
              <button
                id="guardar-enviar"
                className="btn btn-primary"
                type="submit"
                onClick={guardar}
              >
                Guardar y enviar
              </button>

              <button
                id="cancelar"
                className="btn btn-secondary"
                type="button"
                onClick={handleCancel}
              >
                Cancelar
              </button>
            </div>
          </div>
        </form>

        <Modal
          isOpen={modalIsOpen}
          onRequestClose={cerrarModalPrevia}
          contentLabel="Vista Previa"
          style={customStyles}
        >
          <div className="modal-buttons">
            <button onClick={cerrarModalPrevia} className="eliminarBtnModal">
              Cerrar
            </button>
          </div>
        </Modal>

        {mostrarTabla && (
          <Generador numeroReporte={numeroReporte} reportes={reportes} />
        )}
      </div>

      {/* Modal de configuración */}
      <Modal
        isOpen={modalConfigIsOpen}
        onRequestClose={() => setModalConfigIsOpen(false)}
        style={modalNoCotizacion}
      >
        <h2 style={modalNoCotizacion.h2}>
          Configurar preferencias de número de cotización
        </h2>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            guardarConfiguracionNumeroReporte();
          }}
          style={modalNoCotizacion.form}
        >
          <div style={modalNoCotizacion.radioGroup}>
            <label style={modalNoCotizacion.radioLabel}>
              <input
                type="radio"
                name="modoNumeroCotizacion"
                value="auto"
                checked={modoNumeroReporte === "auto"}
                onChange={handleModoCambio}
                style={modalNoCotizacion.radioInput}
              />
              Continuar generando automáticamente números de cotización
            </label>

            {modoNumeroReporte === "auto" && (
              <div style={modalNoCotizacion.inputGroup}>
                <label htmlFor="prefijo" style={modalNoCotizacion.inlineLabel}>
                  Prefijo
                </label>
                <input
                  type="text"
                  id="prefijo"
                  value={prefijo}
                  onChange={(e) => setPrefijo(e.target.value)}
                  style={modalNoCotizacion.smallInput}
                />

                <label
                  htmlFor="siguienteNumero"
                  style={modalNoCotizacion.inlineLabel}
                >
                  Siguiente número
                </label>
                <input
                  type="text"
                  id="siguienteNumero"
                  // Aquí formateamos con ceros a la izquierda:
                  value={String(siguienteNumero).padStart(4, "0")}
                  onChange={(e) => {
                    // Quitamos ceros iniciales para convertir correctamente
                    const raw = e.target.value.replace(/^0+/, "");
                    const numeric = raw === "" ? 0 : parseInt(raw, 10);
                    setSiguienteNumero(isNaN(numeric) ? 0 : numeric);
                  }}
                  style={modalNoCotizacion.smallInput}
                />
              </div>
            )}
          </div>

          <label style={modalNoCotizacion.radioLabel}>
            <input
              type="radio"
              name="modoNumeroCotizacion"
              value="manual"
              checked={modoNumeroReporte === "manual"}
              onChange={handleModoCambio}
              style={modalNoCotizacion.radioInput}
            />
            Introduzca manualmente los números de cotización
          </label>

          <div style={modalNoCotizacion.buttonContainer}>
            <button
              type="button"
              onClick={() => setModalConfigIsOpen(false)}
              style={{
                ...modalNoCotizacion.button,
                ...modalNoCotizacion.buttonCancel,
              }}
            >
              Cancelar
            </button>
            <button type="submit" style={modalNoCotizacion.button}>
              Guardar
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default GeneradorModal;
